import { ChevronIcon } from "components/Icons";
import { ClariahLink } from "components/ClariahLink";
import { Fragment } from "react";
import { PAGE_TYPE } from "shared/constants";
import { useRouter } from "next/router";
import cx from "classnames";
import styles from "./Pagination.module.css";

export const Pagination = ({ current, total }) => {
  const router = useRouter();

  const pageNumbersToShow = [
    ...new Set(
      [
        1,
        current - 3,
        current - 2,
        current - 1,
        current,
        current + 1,
        current + 2,
        current + 3,
        total,
      ].filter((number) => number > 0 && number <= total)
    ),
  ];

  return (
    <div className={styles.container}>
      <ClariahLink
        className={cx(styles.nextPrev, { [styles.hidden]: current < 2 })}
        href={{
          pathname: router.pathname,
          query: {
            ...router.query,
            page: current - 1,
          },
        }}
        type={PAGE_TYPE}
      >
        <ChevronIcon />
        <span>Vorige</span>
      </ClariahLink>

      <div className={styles.numbersContainer}>
        {pageNumbersToShow.map((page, index) => (
          <Fragment key={page}>
            <ClariahLink
              className={cx(styles.number, {
                [styles.isActive]: page === current,
              })}
              href={{
                pathname: router.pathname,
                query: {
                  ...router.query,
                  page,
                },
              }}
              type={PAGE_TYPE}
            >
              {page}
            </ClariahLink>
            {page + 1 !== pageNumbersToShow[index + 1] && page + 1 < total && (
              <div className={styles.numberSpacer}>...</div>
            )}
          </Fragment>
        ))}
      </div>

      <div className={styles.numbersIndex}>
        {current} / {total}
      </div>

      <ClariahLink
        className={cx(styles.nextPrev, { [styles.hidden]: current >= total })}
        href={{
          pathname: router.pathname,
          query: {
            ...router.query,
            page: current + 1,
          },
        }}
        type={PAGE_TYPE}
      >
        <span>Volgende</span>
        <ChevronIcon />
      </ClariahLink>
    </div>
  );
};
